'use client';

import * as React from 'react';
export const CalendarGridDayRowContext = /*#__PURE__*/React.createContext(undefined);
if (process.env.NODE_ENV !== "production") CalendarGridDayRowContext.displayName = "CalendarGridDayRowContext";
export function useCalendarGridDayRowContext() {
  const context = React.useContext(CalendarGridDayRowContext);
  if (context === undefined) {
    throw /* FIXME (minify-errors-in-prod): Unminified error message in production build! */new Error('MUI X Scheduler: CalendarGridDayRowContext is missing. ' + '<CalendarGrid.DayEvent /> must be placed within <CalendarGrid.DayRow />. ' + 'Ensure the component hierarchy is correct.');
  }
  return context;
}